var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3498 7.96632C35.3738 8.3135 35.3738 8.66067 35.3738 9.01105C35.3738 19.6872 27.2463 32 12.3848 32V31.9936C7.9947 32 3.69577 30.7425 0 28.3714C0.63836 28.4482 1.27992 28.4866 1.92308 28.4882C5.56125 28.4914 9.09543 27.2707 11.9576 25.0228C8.50027 24.9572 5.46846 22.703 4.40932 19.412C5.62045 19.6456 6.86837 19.5976 8.05709 19.2728C4.28773 18.5113 1.5759 15.1995 1.5759 11.3533C1.5759 11.3181 1.5759 11.2845 1.5759 11.2509C2.69903 11.8765 3.95655 12.2236 5.24287 12.262C1.69269 9.8894 0.598362 5.16649 2.74223 1.47393C6.84437 6.52161 12.8968 9.59021 19.394 9.91499C18.7428 7.10877 19.6324 4.16816 21.7314 2.19548C24.9856 -0.863526 30.1037 -0.706735 33.1627 2.54586C34.9722 2.18908 36.7065 1.52512 38.2936 0.584383C37.6904 2.45466 36.4281 4.04337 34.7418 5.0529C36.3433 4.86411 37.908 4.43534 39.3815 3.78098C38.2968 5.40648 36.9305 6.82239 35.3498 7.96632Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0d75cb0fe6d809127e16ee6762fb2a42.svg";
export { ForwardRef as ReactComponent };